import React, { useCallback, useEffect, useState } from "react";

import parse, { domToReact } from "html-react-parser";

import { getFullPage } from "services";

import { recordPageView, useCancelAsyncOnUnmount, useNavigate, useParams, useTranslation } from "utils";

import { Col, ErrorBoundary, Image, LazyLoadImage, Link, MainPage, Row, ScreenError, Typography } from "components";

const Page = () => {
  const { t } = useTranslation(["meta"]);
  const { link } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [currentLink, setCurrentLink] = useState(false);
  const [page, setPage] = useState(false);
  const [html, setHtml] = useState("");
  const [image, setImage] = useState(false);
  const [share, setShare] = useState({
    title: t("meta:page.title"),
    summary: t("meta:page.description"),
    link: `${process.env.REACT_APP_FARM_URL}/page/${link}`,
    image: `${process.env.REACT_APP_FARM_URL}/images/misc/share.png`,
  });
  const signal = useCancelAsyncOnUnmount()();

  const loadPage = useCallback(() => {
    getFullPage({
      link: link,
      signal,
    })
      .then((res) => {
        const options = {
          replace: ({ attribs, children }) => {
            if (!attribs) {
              return;
            }

            if (attribs.href && attribs.href.includes(process.env.REACT_APP_FARM_URL)) {
              return (
                <Link to={attribs.href.replace(process.env.REACT_APP_FARM_URL, "")} mixpanelText="page-link">
                  {domToReact(children, options)}
                </Link>
              );
            }
            if (attribs.src) {
              return (
                <LazyLoadImage width={attribs.width} height={attribs.height} src={attribs.src} className="zoom-image" onClick={() => setImage(attribs.src)} />
              );
            }
          },
        };

        if (res) {
          setPage(res);
          setHtml(parse(res.content, options));
        }

        setShare({
          title: `${res.htmlTitle}`,
          link: `${process.env.REACT_APP_FARM_URL}/page/${res.link}`,
          summary: `${res.htmlDescription}`,
          image: `${process.env.REACT_APP_FARM_URL}/images/misc/share.png`,
        });
      })
      .catch(() => {
        navigate("/");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [link, signal, navigate]);

  const loadStuff = useCallback(() => {
    setLoading(true);
    setCurrentLink(link);
    loadPage();
    recordPageView("page", link);
  }, [link, loadPage]);

  useEffect(() => {
    if (link && currentLink !== link) {
      loadStuff();
    }
  }, [loadStuff, currentLink, link]);

  useEffect(() => {
    if (link && currentLink !== link) {
      loadStuff();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"general-page"} share={share}>
      {!loading && page ? (
        <>
          <div className="post">
            <Row>
              <Col>{<Typography variant="h1">{page?.title}</Typography>}</Col>
            </Row>
            <Row>
              <Col> {html} </Col>
            </Row>
          </div>
          <Image src={image} hidePreview={true} onVisibleChange={() => setImage(false)} />
        </>
      ) : (
        <ErrorBoundary>
          <ScreenError headline={t("errorPage.headline")} description={t("errorPage.description")} buttonText={t("errorPage.button")} />
        </ErrorBoundary>
      )}
    </MainPage>
  );
};

export default Page;
